export default function HeaderImage() {
  return (
    <div className="w-full h-[280px] sm:h-[320px] md:h-[400px] lg:h-[450px] overflow-hidden mt-16">
      <img
        src="https://storage.helloreaddy.io/project_files/680aef05-56bc-4648-b1e2-fde388d1b31a/34085969-59b7-4e57-ae76-e85df049ff49_compressed_photo-pont.webp"
        alt="Pont de Plougastel — Finistère"
        className="w-full h-full object-cover"
        style={{ objectPosition: 'center 65%' }}
      />
    </div>
  );
}